module.exports = __webpack_public_path__ + "img/white-alert.4687d3c2.svg";